import Vue from 'vue';

export interface InterfaceLogger {
  info(msg: any): any;
  warn(msg: any): any;
  error(msg: any, err: Error): any;
}

class Logger implements InterfaceLogger {
  public info(msg: any) {
    // eslint-disable-next-line
    console.info(msg);
  }

  public warn(msg: any) {
    // eslint-disable-next-line
    console.warn(msg);
  }

  public error(msg: any, err: Error) {
    // eslint-disable-next-line
    console.error(msg, err);
    Vue.$toast.error(err.message);
  }
}

export default new Logger();
